module.exports = __webpack_public_path__ + "21b215e781045b0d2503e0694f20e312.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-ThinItalic.ttf
// module id = 983
// module chunks = 0